import * as _ from 'styled-components/cssprop';
import { hot } from 'react-hot-loader/root';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CustomFormPage } from './pages/Form/CustomFormPage';
import 'react-router-modal/css/react-router-modal.css';
import ReactGA from 'react-ga';
import { EmployeePage } from './pages/Employees/EmployeePage';
import { CompanyDispatcher } from './dispatchers/CompanyDispatcher';
import { LocationDispatcher } from './dispatchers/LocationDispatcher';
import { PlaceDispatcher } from './dispatchers/PlaceDispatcher';
import { PaymentStatusPage } from './pages/Employees/PaymentStatusPage';
import GlobalStyles from 'styles/GlobalStyles';

const App = () => {
  ReactGA.initialize(TRACKING_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <BrowserRouter>
      <GlobalStyles />
      <Routes>
        <Route
          path="/cd:hash/*"
          element={<CompanyDispatcher qrType="delivery" />}
        />
        <Route
          path="/cp:hash/*"
          element={<CompanyDispatcher qrType="place" />}
        />
        <Route
          path="/ld:hash/*"
          element={<LocationDispatcher qrType="delivery" />}
        />
        <Route
          path="/lp:hash/*"
          element={<LocationDispatcher qrType="place" />}
        />
        <Route path="/pl:hash/*" element={<PlaceDispatcher qrType="place" />} />
        <Route
          path="/ce:hash"
          element={<EmployeePage entityType={'company'} />}
        />
        <Route
          path="/le:hash"
          element={<EmployeePage entityType={'location'} />}
        />
        <Route
          path="/pc:hash"
          element={<EmployeePage entityType={'personal'} />}
        />
        <Route
          path="/ce:hash/tips/:uuid"
          element={<PaymentStatusPage type={'company'} />}
        />
        <Route
          path="/le:hash/tips/:uuid"
          element={<PaymentStatusPage type={'location'} />}
        />
        <Route
          path="/pc:hash/tips/:uuid"
          element={<PaymentStatusPage type={'personal'} />}
        />
        <Route path="/:shortUrl/c/:hash" element={<CustomFormPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default hot(App);
